import React from 'react';
import { useNavigate } from 'react-router-dom';
import LinkAnalyticsDemo from './LinkAndFanHub/components/LinkAnalyticsDemo';
import BioLinkPreview from './LinkAndFanHub/LinkPreview/BioLinkPreview';
import FacebookIcon from "../../assets/images/icons/facebook-icon.png"
import InstagramIcon from "../../assets/images/admin/Instagram.png"
import YoutubeMusicIcon from "../../assets/images/icons/youtubemusic.webp"
import SpotifyIcon from "../../assets/images/admin/Spotify.svg";
import DeezerIcon from "../../assets/images/icons/deezer_logo.png";
import SoundCloudIcon from "../../assets/images/icons/soundcloud.svg";
import AppleMusicIcon from '../../assets/images/icons/apple-music.png';
import { socialPlatformsArray } from './LinkAndFanHub/constants/socialPlatforms';
import { BIO_STREAMING_PLATFORMS } from './LinkAndFanHub/constants/streamingPlatforms';

export default function LinkAnalyticsDemoPage() {
    const navigate = useNavigate();

    const handleStartTour = () => {
        navigate('#start-tour');
    };

    return (
        <div className="min-h-screen bg-gray-50 p-4">
            <div className="max-w-7xl mx-auto">
                <div className="mb-6 flex items-center justify-between">
                    <div>
                        <h1 className="text-3xl font-bold text-gray-900">Link Analytics Demo</h1>
                        <p className="text-gray-600 mt-2">
                            This is a demonstration of the Link Analytics page with mock data.
                            All data shown below is for demonstration purposes only.
                        </p>
                    </div>
                </div>

                <div className="bg-white rounded-lg shadow-lg p-6">
                    <div className="grid grid-cols-1 lg:grid-cols-[1fr_350px] gap-6">
                        <div className="left-col">
                            <LinkAnalyticsDemo />
                        </div>
                        <div className="right-section w-full mx-auto mt-6">
                            <div data-tour="mobile-demo">
                                <BioLinkPreview previewData={{
                                    linktype: 'biolink',
                                    background: { type: 'color', value: '#000' },
                                    title: 'Your Name',
                                    description: 'This is a demo mobile preview for Link Analytics.',
                                    image: require('../../assets/images/logo.png'),
                                    socialPlatforms: socialPlatformsArray,
                                    platforms: BIO_STREAMING_PLATFORMS.map(p => ({ ...p, url: p.url || '#' }))
                                }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
